import { configureStore } from '@reduxjs/toolkit'
import { appReducer as app, AppState } from '../reducers/app.reducer'
import { authReducer as auth, AuthState } from '../reducers/auth.reducer'
import { userReducer as user, UserState } from '../reducers/user.reducer'

export const store = configureStore({
  reducer: {
    app,
    auth,
    user
  }
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
